import { selectOptionFor } from "../utils/inputs_utils";
import { formattedDate, isFlatpickrInput, flatpickrAltInput, dynamicDateRange } from "../utils/date_utils";
import { numericRange } from "../utils/number_utils";
import { i18nTranslations } from "../utils/i18n_utils";

export const clearInputValue = (input) => {
  if (["checkbox", "radio"].includes(input.type)) {
    input.checked = false;
  } else if (isFlatpickrInput(input)) {
    input.value = "";
    flatpickrAltInput(input).value = "";
  } else if (input.type === "select-one") {
    selectOptionFor(input, null);
  } else {
    input.value = "";
  }
};

export const dispatchFilterPreselectedEvent = (payload) => {
  document.dispatchEvent(new CustomEvent("datatable:filterPreselected", { detail: payload }));
};

export const dispatchFilterSelectedEvent = (payload) => {
  document.dispatchEvent(new CustomEvent("datatable:filterSelected", { detail: payload }));
};

export const dispatchFilterUpdatedEvent = (payload) => {
  document.dispatchEvent(new CustomEvent("datatable:filterUpdated", { detail: payload }));
};

export const getFilterLabel = (filterName) => {
  return i18nTranslations().t(filterName, { scope: "datatable_filters" });
};

export const dateRangeLabel = (startDate, endDate) => {
  if (!startDate && !endDate) {
    return;
  }

  let value = `Du ${formattedDate(startDate)} au ${formattedDate(endDate)}`;
  if (!startDate) {
    value = `Jusqu'au ${formattedDate(endDate)}`;
  } else if (!endDate) {
    value = `Depuis le ${formattedDate(startDate)}`;
  }

  return value;
};

const periodFilter = () => {
  let period;
  const selectedPeriodInput = document.querySelector("[name='period-filter']:checked");

  if (selectedPeriodInput) {
    period = selectedPeriodInput.value;
  }
  return period;
};

export const computePeriodDateRange = (startDateId = "start-date-filter", endDateId = "end-date-filter") => {
  let period = periodFilter();
  const startDateFilter = document.getElementById(startDateId);
  const endDateFilter = document.getElementById(endDateId);
  if ((startDateFilter && startDateFilter.value) || (endDateFilter && endDateFilter.value)) {
    period = dynamicDateRange([startDateFilter.value, endDateFilter.value]).join(":");
  }
  return period;
};

export const dateRangeFilterValue = (startDate, endDate) => {
  return dynamicDateRange([startDate, endDate]).join(":");
};

export const amountFilterRange = (amountInputs, rangeStart, rangeEnd) => {
  let range;
  const { amountEqInput, amountLtInput, amountGtInput, amountBwInput } = amountInputs;

  if (amountEqInput.checked) {
    range = numericRange(null, null, rangeStart);
  } else if (amountLtInput.checked) {
    range = numericRange(-Number.MAX_SAFE_INTEGER, rangeStart);
  } else if (amountGtInput.checked) {
    range = numericRange(rangeStart);
  } else if (amountBwInput.checked) {
    range = numericRange(rangeStart, rangeEnd);
  }
  return range;
};
